import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './relatorioForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import ReactExport from 'react-export-excel-fixed-xlsx';

import { 
	setModoTela, initForm, salvar, excluir, getLista, getListaModeloRelatorio, getListaChecklistResposta,
	getListaArea, getListaPergunta, getListaRespostaItem, getListaEstrutura,
	getListaCliente, getListaChecklist, getListaUsuario, getListaGrupo
} from './relatorioActions';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class Relatorio extends Component {

	state = {
		linhaSelecionada: null,
		paginacaoIndice: 0,
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(186)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual()),
		ids_checklist: [],
		ids_cliente: [],
		ids_usuario: [],
		ids_grupo: []
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaModeloRelatorio();
		this.props.getListaChecklistResposta();
		this.props.getListaCliente();
		this.props.getListaChecklist();
		this.props.getListaUsuario();
		this.props.getListaGrupo();
    
		const idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaModeloRelatorio();
			this.props.getListaChecklistResposta();
			this.props.getListaChecklist();
		}, 40000);

		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}

	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}

	}

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'cadastroVisualizar' ? (
						<Form visualizar onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }
	
	normalizarTexto(texto) {
		return (texto || '').normalize('NFD') // separa acentos
			.replace(/[\u0300-\u036f]/g, '') // remove acentos
			.toUpperCase(); // ignora maiúsc/minúsc
	}

	filtrarChecklistResposta(todos = false) {

		return this.props.listaChecklistResposta.filter((item, i) => {
			return this.props.lista.filter(relatorio => (relatorio.checklist_respostas || []).includes(item.id)).length == 0
		}).filter(item => {
			if (todos) {
				return true;
			} else if (item.id_status != 3 && item.id_status != 4) {
				//Apenas concluídos ou finalizados
				return false;
			}
			return true;
		}).filter(item => {
			if (this.state.pesquisar
				&& !this.normalizarTexto(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
					${DateFormat.formatarDataSqlParaTela(item.data_checklist)}
					${item.nome_cliente || ''}
					${item.nome_cidade || ''}${item.nome_cidade && item.nome_estado ? '/' : ''}${item.nome_estado || ''}
					${item.nome_checklist || ''}
					${item.nome_status == 'Concluído' && item.configuracao_checklist_analise ? 'Aguardando Análise' : item.nome_status || ''}
					${item.nome_usuario || ''}					
				`).includes(this.normalizarTexto(this.state.pesquisar))) {
				return false;
			}
			if (this.state.data_inicial
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_agendamento || item.datahora_inclusao)) < DateFormat.formatarDataTelaParaSql(this.state.data_inicial)) {
				return false;
			}
			if (this.state.data_final
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.data_agendamento || item.datahora_inclusao)) > DateFormat.formatarDataTelaParaSql(this.state.data_final)) {
				return false;
			}

			if ((this.state.ids_checklist || []).length && !(this.state.ids_checklist || []).includes(item.id_checklist)) {
				return false;
			}
			if ((this.state.ids_cliente || []).length && !(this.state.ids_cliente || []).includes(item.id_cliente)) {
				return false;
			}
			if ((this.state.ids_usuario || []).length && !(this.state.ids_usuario || []).includes(item.id_usuario)) {
				return false;
			}
			if ((this.state.ids_grupo || []).length && !(this.state.ids_grupo || []).includes(item.id_grupo)) {
				return false;
			}

			return true;
		});

	}

	filtrarRelatorio() {

		return this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !this.normalizarTexto(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
					${DateFormat.formatarDataSqlParaTela(item.data_checklist)}
					${String(item.id).padStart(7, '0') || ''}
					${item.nome_modelo_relatorio || ''}
					${item.nome_cliente || ''}
					${item.nome_cidade || ''}${item.nome_cidade && item.nome_estado ? '/' : ''}${item.nome_estado || ''}
					${(item.respostas || []).map(resposta => resposta.nome_checklist).join(', ') || ''}
					${item.nome_usuario_checklist || ''}
					${item.nome_usuario_inclusao || ''}
				`).includes(this.normalizarTexto(this.state.pesquisar))) {
				return false;
			}

			if (this.state.data_inicial 
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)) < DateFormat.formatarDataTelaParaSql(this.state.data_inicial)) {
				return false;
			}
			if (this.state.data_final 
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_inclusao)) > DateFormat.formatarDataTelaParaSql(this.state.data_final)) {
				return false;
			}

			if (!(item.respostas || []).filter(resposta => {
				if ((this.state.ids_checklist || []).length && !(this.state.ids_checklist || []).includes(resposta.id_checklist)) {
					return false;
				}
				if ((this.state.ids_cliente || []).length && !(this.state.ids_cliente || []).includes(resposta.id_cliente)) {
					return false;
				}
				if ((this.state.ids_usuario || []).length && !(this.state.ids_usuario || []).includes(resposta.id_usuario)) {
					return false;
				}
				if ((this.state.ids_grupo || []).length && !(this.state.ids_grupo || []).includes(resposta.id_grupo)) {
					return false;
				}

				return true;
			}).length) {
				return false;
			}

			return true;
		});

	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		let listaChecklistResposta = this.filtrarChecklistResposta();

		let lista = this.filtrarRelatorio();

		let paginacao = [];

		if (this.props.lista.length) {
			for (let i = 0; i < this.props.lista.length; i += 500) {				
				paginacao.push({
					inicio: i,
					fim: i + 499
				});				
			}
		} else {
			paginacao.push({
				inicio: 0,
				fim: 499
			});
		}

		return (
			<ContentCard>				
				<ContentCardHeader>

					<Row>

						<LabelAndInputMask
							label='Data Inicial'
							cols='12 12 6 2'
							placeholder='Informe'
							mask={'99/99/9999'}
							value={this.state.data_inicial}
							onChange={data => {
								this.setState({
									...this.state,
									data_inicial: data.target.value
								});
							}} />

						<LabelAndInputMask
							label='Data Final'
							cols='12 12 6 2'
							placeholder='Informe'
							mask={'99/99/9999'}
							value={this.state.data_final}
							onChange={data => {
								this.setState({
									...this.state,
									data_final: data.target.value
								});
							}} />

						<Select
							options={this.props.listaGrupo}
							label='Região / Grupo'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_grupo}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_grupo: values.map(item => item.value)
								});
							}} />

						<Select
							options={this.props.listaCliente.filter(item => !(this.state.ids_grupo || []).length || (this.state.ids_grupo || []).includes(item.id_grupo))}
							label='Cliente'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_cliente}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_cliente: values.map(item => item.value)
								});
							}} />

						<Select
							options={this.props.listaUsuario.map(item => ({ id: item.id, valor: item.nome }))}
							label='Aplicador'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_usuario}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_usuario: values.map(item => item.value)
								});
							}} />

						<Select
							options={this.props.listaChecklist}
							label='Checklist'
							cols='12 12 6 2'
							placeholder='Selecione'
							marginBottomFormGroup={0}
							value={this.state.ids_checklist}
							multiple
							onChange={values => {
								this.setState({
									...this.state,
									ids_checklist: values.map(item => item.value)
								});
							}} />
					
					</Row>

					<Row>
						<Grid cols='12 8 9 10'>
						<input className='form-control'
							placeholder='Pesquisar'
							type='text'
							value={this.state.pesquisar}
							onChange={e => {
								this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
							}} />
						</Grid>
						<Grid cols='12 4 3 2'>
							<ExcelFile
								filename={'Relatórios'}
								element={
									<Button
										text='Exportar'
										type={'success'}
										icon={'fa fa-plus'} />
								}>
								{this.montarExcel(this.filtrarChecklistResposta(true), this.filtrarRelatorio())}
							</ExcelFile>

						</Grid>
					</Row>
				</ContentCardHeader>
			
				<ContentCardBody>	
					<Row>
						<Grid cols='12 12 12 12'>
							<h5 style={{ textAlign: 'center', color: '#ffffff', backgroundColor: '#f57215', fontWeight: 'bold', padding: 8 }}>Relatórios Pendentes</h5>
						</Grid>
					</Row>
					
					<Table responsive>
						<THead>
							<Tr>
								<Th>Agendamento</Th>
								<Th>Dt Informada</Th>
								<Th alignCenter>Cliente</Th>
								<Th alignCenter>Cidade/Estado</Th>
								<Th alignCenter>Checklist</Th>
								<Th alignCenter>Status</Th>
								<Th alignCenter>Usuário</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{listaChecklistResposta.map(item => (
								<Tr key={item.id} >
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_checklist)}</Td>
									<Td alignCenter>{item.nome_cliente}</Td>
									<Td alignCenter>{item.nome_cidade}{item.nome_cidade && item.nome_estado ? '/' : ''}{item.nome_estado}</Td>
									<Td alignCenter>{item.nome_checklist}</Td>
									<Td alignCenter>{item.nome_status == 'Concluído' && item.configuracao_checklist_analise ? 'Aguardando Análise' : item.nome_status}</Td>
									<Td alignCenter>{item.nome_usuario}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={true}
											event={() => {
												this.props.setModoTela('cadastroVisualizar', {
													checklist_respostas: [item.id],
													id_checklist: item.id_checklist,
													id_modelo_relatorio: item.id_modelo_relatorio
												});
												this.props.initForm({
													checklist_respostas: [item.id],
													checklist_resposta_objeto: { ...item },
													id_checklist: item.id_checklist,
													id_modelo_relatorio: item.id_modelo_relatorio,
													nome_cliente: item.nome_cliente,
													modoRejeitar: item.id_status == 3 || item.id_status == 4,
													modoFinalizar: item.id_status == 3
												});
												this.props.getListaEstrutura([item]);
											}} />

										<ButtonTable
											type={'success'}
											icon={'fas fa-plus'}
											visible={true}
											disabled={!(item.id_status == 3 && !item.configuracao_checklist_analise) && item.id_status != 4 /*FINALIZADO*/}
											event={() => {
												this.props.setModoTela('cadastro', {
													checklist_respostas: [item.id],
													id_checklist: item.id_checklist,
													id_modelo_relatorio: item.id_modelo_relatorio
												});
												this.props.initForm({
													checklist_respostas: [item.id],
													id_checklist: item.id_checklist,
													id_modelo_relatorio: item.id_modelo_relatorio,
													nome_cliente: item.nome_cliente,
													listaOutros: listaChecklistResposta.filter((itemAux, i) => (
														this.props.lista.filter(relatorio => (relatorio.checklist_respostas || []).includes(itemAux.id)).length == 0 
														&& itemAux.id_cliente == item.id_cliente
														&& (
															(itemAux.id_status == 3 && !itemAux.configuracao_checklist_analise)
															|| itemAux.id_status == 4
														)
													))
												});

												this.props.getListaEstrutura([]);

												// this.props.getListaArea([]);
												// this.props.getListaPergunta([]);
												// this.props.getListaRespostaItem([]);
											}} />
										</Td>
									</Tr>
								))}
							</TBody>
					</Table>	
										
					{/*<ul class='pagination pagination-sm m-0 float-right'>
						<li class='page-item'>
							<a class='page-link' 
								style={{ 
									cursor: 'pointer'
								}}
								onClick={() => this.setState({
									...this.state,
									paginacaoIndice: this.state.paginacaoIndice > 0 ? this.state.paginacaoIndice - 1 : this.state.paginacaoIndice
								})}>{'<<'}
							</a>
						</li>
						
						{paginacao.map((item, i) => (
							<li class='page-item'>
								<a class='page-link'  
									style={{ 
										fontWeight: 'bold',
										cursor: 'pointer',
										backgroundColor: i == this.state.paginacaoIndice ? '#f57215' : null,
										color: i == this.state.paginacaoIndice ? '#fff' : null
									}}
									onClick={() => this.setState({
										...this.state,
										paginacaoIndice: i
									})}>{i + 1}
								</a>
							</li>
						))}
						
						<li class='page-item'>
							<a class='page-link' 
								style={{ 
									cursor: 'pointer'
								}}
								onClick={() => this.setState({
									...this.state,
									paginacaoIndice: paginacao.length - 1 > this.state.paginacaoIndice ? this.state.paginacaoIndice + 1 : this.state.paginacaoIndice
								})}>{'>>'}
							</a>
						</li>
					</ul>*/}

					<Row>
						<Grid cols='12 12 12 12'>
							<h5 style={{ textAlign: 'center', color: '#ffffff', backgroundColor: '#f57215', fontWeight: 'bold', padding: 8 }}>Relatórios Finalizados</h5>
						</Grid>
					</Row>

					<Table responsive>
						<THead>
							<Tr>
								<Th>Relatório Gerado</Th>
								<Th>Dt Informada</Th>
								<Th alignCenter>Número</Th>
								<Th alignCenter>Modelo</Th>
								<Th alignCenter>Cliente</Th>
								<Th alignCenter>Cidade/Estado</Th>
								<Th alignCenter>Checklist</Th>
								<Th alignCenter>Usuário Checklist</Th>
								<Th alignCenter>Usuário Relatório</Th>
								<Th minWidth={100}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.filter((item, i) => {
								return i >= paginacao[this.state.paginacaoIndice].inicio && i <= paginacao[this.state.paginacaoIndice].fim;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
									<Td>{DateFormat.formatarDataSqlParaTela(item.data_checklist)}</Td>
									<Td alignCenter>{String(item.id).padStart(7, '0')}</Td>
									<Td alignCenter>{item.nome_modelo_relatorio}</Td>
									<Td alignCenter>{item.nome_cliente}</Td>
									<Td alignCenter>{item.nome_cidade}{item.nome_cidade && item.nome_estado ? '/' : ''}{item.nome_estado}</Td>
									<Td alignCenter>{(item.respostas || []).map(resposta => resposta.nome_checklist).join(', ')}</Td>
									<Td alignCenter>{item.nome_usuario_checklist}</Td>
									<Td alignCenter>{item.nome_usuario_inclusao}</Td>
									<Td alignRight minWidth={100}>																			
										<ButtonTable
											type={'primary'}
											icon={'fas fa-eye'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});

												this.props.getListaEstrutura(item.respostas);

												// this.props.getListaArea(item.respostas);
												// this.props.getListaPergunta(item.respostas);
												// this.props.getListaRespostaItem(item.respostas);
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(listaChecklist, listaRelatorio) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		var quebrarData = data => {
			
			if (data) {
				const dataFormatada = DateFormat.formatarDataSqlParaTela(data);
				return {
					dia: dataFormatada.split('/')[0],
					mes: dataFormatada.split('/')[1],
					ano: dataFormatada.split('/')[2]
				};
			}

			return {
				dia: null,
				mes: null,
				ano: null
			};
		}

		let lista = [];
		listaChecklist.forEach(item => {
			lista.push({				
				status: 'Relatórios Pendentes',
				status_checklist: item.nome_status == 'Concluído' && item.configuracao_checklist_analise ? 'Aguardando Análise' : item.nome_status,
				datahora_inclusao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao),
				dia_inclusao: quebrarData(item.datahora_inclusao).dia,
				mes_inclusao: quebrarData(item.datahora_inclusao).mes,
				ano_inclusao: quebrarData(item.datahora_inclusao).ano,
				data_checklist: DateFormat.formatarDataSqlParaTela(item.data_checklist),
				dia_checklist: quebrarData(item.data_checklist).dia,
				mes_checklist: quebrarData(item.data_checklist).mes,
				ano_checklist: quebrarData(item.data_checklist).ano,
				data_fim_checklist: DateFormat.formatarDataSqlParaTela(item.data_fim_checklist),
				dia_fim_checklist: quebrarData(item.data_fim_checklist).dia,
				mes_fim_checklist: quebrarData(item.data_fim_checklist).mes,
				ano_fim_checklist: quebrarData(item.data_fim_checklist).ano,
				id: null,
				nome_modelo_relatorio: null,
				nome_cliente: item.nome_cliente_apenas,
				id_integracao_cliente: item.id_integracao_cliente,
				cpf_cnpj_cliente: item.cpf_cnpj_cliente,
				nome_cidade: item.nome_cidade,
				nome_estado: item.nome_estado,
				nome_pais: item.nome_pais,
				nome_grupo: item.nome_grupo,
				qtd_checklists: 1,
				checklists: item.nome_checklist,
				distancia_percorrida: item.distancia_percorrida,
				quantidade_pessoas_treinadas: item.quantidade_pessoas_treinadas,
				nome_usuario_checklist: item.nome_usuario,
				nome_usuario_inclusao: item.nome_usuario_inclusao
			});
		});

		listaRelatorio.forEach(item => {
			lista.push({
				status: 'Relatórios Finalizados',
				status_checklist: 'Finalizado',
				datahora_inclusao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao),
				dia_inclusao: quebrarData(item.datahora_inclusao).dia,
				mes_inclusao: quebrarData(item.datahora_inclusao).mes,
				ano_inclusao: quebrarData(item.datahora_inclusao).ano,
				data_checklist: DateFormat.formatarDataSqlParaTela(item.data_checklist),
				dia_checklist: quebrarData(item.data_checklist).dia,
				mes_checklist: quebrarData(item.data_checklist).mes,
				ano_checklist: quebrarData(item.data_checklist).ano,
				data_fim_checklist: DateFormat.formatarDataSqlParaTela(item.data_fim_checklist),
				dia_fim_checklist: quebrarData(item.data_fim_checklist).dia,
				mes_fim_checklist: quebrarData(item.data_fim_checklist).mes,
				ano_fim_checklist: quebrarData(item.data_fim_checklist).ano,
				hora_inicio_checklist: item.hora_inicio_checklist,
				hora_fim_checklist: item.hora_fim_checklist,
				carga_horaria_checklist: item.carga_horaria_checklist,
				id: String(item.id).padStart(7, '0'),
				nome_modelo_relatorio: item.nome_modelo_relatorio,
				nome_cliente: item.nome_cliente_apenas,
				id_integracao_cliente: item.id_integracao_cliente,
				cpf_cnpj_cliente: item.cpf_cnpj_cliente,
				nome_cidade: item.nome_cidade,
				nome_estado: item.nome_estado,
				nome_pais: item.nome_pais,
				nome_grupo: item.nome_grupo,
				qtd_checklists: (item.respostas || []).length,
				checklists: (item.respostas || []).map(resposta => resposta.nome_checklist).join(', '),
				distancia_percorrida: item.distancia_percorrida,
				quantidade_pessoas_treinadas: item.quantidade_pessoas_treinadas,
				nome_usuario_checklist: item.nome_usuario_checklist,
				nome_usuario_inclusao: item.nome_usuario_inclusao
			});
		});

		return (
			<ExcelSheet data={lista} name='Checklists e Relatórios'>
				{[
					{ componente: <ExcelColumn label='Status' value='status'/>},
					{ componente: <ExcelColumn label='Status do Checklist' value='status_checklist'/>},
					{ componente: <ExcelColumn label='Data e Hora Agendamento' value='datahora_inclusao'/>},
					{ componente: <ExcelColumn label='Dia Agend.' value='dia_inclusao'/>},
					{ componente: <ExcelColumn label='Mês Agend.' value='mes_inclusao'/>},
					{ componente: <ExcelColumn label='Ano Agend.' value='ano_inclusao'/>},

					{ componente: <ExcelColumn label='Data Informada' value='data_checklist'/>},
					{ componente: <ExcelColumn label='Dia Inf.' value='dia_checklist'/>},
					{ componente: <ExcelColumn label='Mês Inf.' value='mes_checklist'/>},
					{ componente: <ExcelColumn label='Ano Inf.' value='ano_checklist'/>},

					{ componente: <ExcelColumn label='Data Fim' value='data_fim_checklist'/>},
					{ componente: <ExcelColumn label='Dia Fim' value='dia_fim_checklist'/>},
					{ componente: <ExcelColumn label='Mês Fim' value='mes_fim_checklist'/>},
					{ componente: <ExcelColumn label='Ano Fim' value='ano_fim_checklist'/>},

					{ componente: <ExcelColumn label='Hora Início' value='hora_inicio_checklist'/>},
					{ componente: <ExcelColumn label='Hora Fim' value='hora_fim_checklist'/>},
					{ componente: <ExcelColumn label='Carga Horária' value='carga_horaria_checklist'/>},

					{ componente: <ExcelColumn label='Número' value='id'/>},
					{ componente: <ExcelColumn label='Modelo' value='nome_modelo_relatorio'/>},
					{ componente: <ExcelColumn label='Cliente' value='nome_cliente'/>},
					{ componente: <ExcelColumn label='ID Cliente' value='id_integracao_cliente'/>},
					{ componente: <ExcelColumn label='CPF/CNPJ' value='cpf_cnpj_cliente'/>},
					{ componente: <ExcelColumn label='Cidade' value='nome_cidade'/>},
					{ componente: <ExcelColumn label='Estado' value='nome_estado'/>},
					{ componente: <ExcelColumn label='País' value='nome_pais'/>},
					{ componente: <ExcelColumn label='Grupo/Região' value='nome_grupo'/>},
					{ componente: <ExcelColumn label='Checklist' value='checklists'/>},
					{ componente: <ExcelColumn label='Distância Percorrida (Km)' value='distancia_percorrida'/>},
					{ componente: <ExcelColumn label='Participantes Treinados' value='quantidade_pessoas_treinadas'/>},
					{ componente: <ExcelColumn label='Usuário Checklist' value='nome_usuario_checklist'/>},
					{ componente: <ExcelColumn label='Usuário Relatório' value='nome_usuario_inclusao'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.relatorio.modoTela,
	aguardando: state.relatorio.aguardando,
	lista: state.relatorio.lista,
	listaChecklistResposta: state.relatorio.listaChecklistResposta,
	listaCliente: state.relatorio.listaCliente,
	listaChecklist: state.relatorio.listaChecklist,
	listaUsuario: state.relatorio.listaUsuario.filter(item => 
		state.auth.usuarioCarregado 
		&& (item.departamentos || []).filter(departamento => (state.auth.usuarioCarregado.departamentos || []).includes(departamento)).length
	),
	listaGrupo: state.relatorio.listaGrupo
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaModeloRelatorio, getListaChecklistResposta,
	getListaArea, getListaPergunta, getListaRespostaItem, getListaEstrutura,
	getListaCliente, getListaChecklist, getListaUsuario, getListaGrupo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Relatorio);